import React, { Fragment } from 'react';

const PrivacyText_de = (
  <Fragment>
    <h1 id="datenschutz-toc-">Datenschutz</h1>
    <h2 id="name-und-anschrift-des-verantwortlichen">
      Name und Anschrift des Verantwortlichen
    </h2>
    <p>
      Der Verantwortliche der Datenverarbeitung im Sinne der Art. 4 Nr. 7
      EU-Datenschutzgrundverordnung (DSGVO), dem Bundesdatenschutzgesetz (BDSG)
      sowie sonstiger datenschutzrechtlicher Bestimmungen ist das
      Umweltbundesamt, vertreten durch den Präsidenten des Umweltbundesamtes:
    </p>
    <p>
      Umweltbundesamt Präsidialbereich / Presse- und Öffentlichkeitsarbeit,
      Internet Wörlitzer Platz 1 06844 Dessau-Roßlau
    </p>
    <p>
      Telefon: +49-340-2103-2416
      <br />
      E-Mail: buergerservice@uba.de
    </p>
    <p>www.umweltbundesamt.de</p>
    <h2 id="name-und-anschrift-des-datenschutzbeauftragten">
      Name und Anschrift des Datenschutzbeauftragten
    </h2>
    <p>
      Für Fragen und Auskünfte rund um das Thema Datenschutz steht Ihnen der
      Datenschutzbeauftragte des Umweltbundesamtes zur Verfügung. Er ist auch
      Ansprechpartner für die Durchsetzung Ihrer Rechte als Betroffene/r:
    </p>
    <p>
      Herrn Udo Langhoff Umweltbundesamt Wörlitzer Platz 1 06844 Dessau-Roßlau
    </p>
    <p>
      Telefon: +49-30-8903-5141
      <br />
      E-Mail: udo.langhoff@uba.de
    </p>
    <h2 id="allgemeines-zur-datenverarbeitung">
      Allgemeines zur Datenverarbeitung
    </h2>
    <p>
      <strong>Umfang der Verarbeitung personenbezogener Daten </strong>
      Das Umweltbundesamt ist eine wissenschaftliche Behörde, deren Aufgabe es
      ist, den Zustand der Umwelt zu beobachten und zu bewerten. Es berät die
      Politik und arbeitet an Gesetzesvorschlägen mit. Es erhebt und analysiert
      eigene Umweltdaten und solche Dritter und arbeitet dabei eng mit den
      Landesumweltbehörden und Gesundheitsbehörden zusammen.
    </p>
    <p>
      Neben der „rein“ wissenschaftlichen Arbeit sind der Vollzug der
      Umweltgesetze – beispielsweise das Umweltinformationsgesetz (§ 10 UIG) –
      und die Information der Bürgerinnen und Bürger in Fragen des
      Umweltschutzes weitere Schwerpunkte. Mit dem Data Cube bietet das UBA
      künftig ein System, um diese Daten auch maschinenlesbar, in offenen
      Dateiformaten und über Schnittstellen open-data-konform zur Verfügung zu
      stellen.
    </p>
    <p>
      Wir verarbeiten personenbezogene Daten der Nutzerinnen und Nutzer unserer
      Website grundsätzlich nur, soweit dies zur Bereitstellung einer
      funktionsfähigen Website sowie unserer Inhalte und Leistungen (wie etwa
      der Kommunikation über ein Kontaktformular) erforderlich ist. Die
      Verarbeitung personenbezogener Daten unserer Nutzerinnen und Nutzer
      erfolgt regelmäßig nur nach deren Einwilligung.
    </p>
    <p>
      Sofern nicht im Einzelfall in dieser Datenschutzerklärung anders
      angegeben, findet keine Weitergabe Ihrer Daten an Dritte statt. Eine
      Verarbeitung und Nutzung Ihrer Daten für Zwecke der Beratung, der Werbung
      und der Marktforschung erfolgt nicht. Die im Redaktionssystem der Website
      gespeicherten Daten können lediglich vom Betriebs-Team des Data Cubes
      eingesehen werden.
    </p>
    <p>
      <strong>
        Rechtsgrundlage für die Verarbeitung personenbezogener Daten
      </strong>
    </p>
    <p>
      Rechtsgrundlage einer Verarbeitung personenbezogener Daten ist eine
      Einwilligung der betroffenen Person gemäß Art. 6 Abs. 1 lit. a der
      EU-Datenschutzgrundverordnung (DSGVO) oder eine der folgenden gesetzlichen
      Regelungen:
    </p>
    <p>
      Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines
      Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich
      ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch
      für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen
      erforderlich sind.
    </p>
    <p>
      <strong>Datenlöschung und Speicherdauer</strong>
    </p>
    <p>
      Die personenbezogenen Daten werden gelöscht oder gesperrt, sobald der
      Zweck der Speicherung entfällt, also etwa eine Anfrage über das
      Kontaktformular bearbeitet wurde.{' '}
    </p>
    <p>
      Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den
      europäischen oder nationalen Gesetzgeber in unionsrechtlichen
      Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der
      Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung
      der Daten erfolgt auch dann, wenn eine durch die genannten Normen
      vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine
      Erforderlichkeit zur weiteren Speicherung der Daten für einen
      Vertragsabschluss oder eine Vertragserfüllung besteht.
    </p>
    <h2 id="bereitstellung-des-data-cubes-und-erstellung-von-logfiles">
      Bereitstellung des Data Cubes und Erstellung von Logfiles
    </h2>
    <p>
      <strong>Beschreibung und Umfang der Datenverarbeitung</strong>
    </p>
    <p>
      Bei jedem Aufruf des Data Cubes erfasst unser System automatisiert Daten
      und Informationen vom Computersystem des aufrufenden Rechners.
    </p>
    <p>Folgende Daten werden hierbei gegebnenfalls erhoben:</p>
    <ol>
      <li>Informationen über den Browsertyp und die verwendete Version</li>
      <li>Das Betriebssystem des Nutzers</li>
      <li>Datum und Uhrzeit des Zugriffs</li>
      <li>Name der abgerufenen Datei</li>
      <li>übertragene Datenmenge</li>
      <li>Meldung, ob der Abruf erfolgreich war</li>
    </ol>
    <p>
      Einige der Daten werden gegebnenfalls in den Logfiles unseres Systems
      gespeichert. Eine Speicherung dieser Daten zusammen mit anderen
      personenbezogenen Daten des Nutzers findet nicht statt.
    </p>
    <p>
      <strong>Zweck der Datenverarbeitung</strong>
    </p>
    <p>
      Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Website
      sicherzustellen. Zudem dienen uns die Daten zur Optimierung der Website
      und zur Sicherstellung der Sicherheit unserer informationstechnischen
      Systeme.
    </p>
    <p>
      Eine Zusammenführung dieser Daten aus der Protokolldatei mit ggf. weiteren
      gespeicherten Daten, wie sie bei Inanspruchnahme anderer Angebote
      verbunden mit der Angabe von persönlichen Daten entstehen, findet nicht
      statt. Ein direkter Bezug von der IP-Nummer aus der Protokolldatei auf
      Ihre Person ist nicht möglich und wird ausgeschlossen. Die IP-Adresse wird
      nur bei Angriffen auf die Internetinfrastruktur des Data Cubes, bei
      Verstößen gegen die guten Sitten sowie bei sonstigen illegalen Handlungen,
      die im Zusammenhang mit der Benutzung des Data Cubes stehen, ausgewertet.
      Ein Rückschluss aus der IP-Nummer auf Ihre Person ist dabei nur über Ihren
      Einwahlprovider durch ein staatsanwaltschaftliches Ermittlungsverfahren
      möglich.
    </p>
    <p>
      <strong>Dauer der Speicherung</strong>
    </p>
    <p>
      Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer
      Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten
      zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige
      Sitzung beendet ist.
    </p>
    <p>
      Bei der Speicherung der Daten in Logfiles ist dies nach spätestens 14
      Tagen der Fall. Eine darüberhinausgehende Speicherung ist möglich. In
      diesem Fall werden die IP-Adressen der Nutzer (soweit für den Zweck
      möglich) gelöscht oder verfremdet, sodass eine Zuordnung des aufrufenden
      Clients nicht mehr möglich ist.
    </p>
    <p>
      <strong>Widerspruchs- und Beseitigungsmöglichkeit</strong>
    </p>
    <p>
      Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung
      der Daten in Logfiles ist für den Betrieb der Internetseite zwingend
      erforderlich.{' '}
    </p>
    <h1 id="verwendung-von-cookies">Verwendung von Cookies</h1>
    <p>
      <strong>Beschreibung und Umfang der Datenverarbeitung</strong>
    </p>
    <p>
      Der Data Cube speichert technisch notwendige Cookies in Ihrem Browser,
      welche zur Identifizierung Ihrer Sitzung bei der Kommunikation mit dem
      Server verwendet werden kann. Nehmen Sie diese Möglichkeit wahr, so werden
      die von Ihnen in der Eingabemaske eingegeben Daten per E-Mail an das
      Umweltbundesamt (Data Cube Team) übermittelt.
    </p>
    <p>Beim Zugriff auf die Seite werden ggf. folgende Daten gespeichert:</p>
    <ol>
      <li>Session-ID</li>
      <li>Datum und Uhrzeit der Anfrage</li>
      <li>Login-Daten für den Datacube</li>
    </ol>
    <p>
      Es erfolgt ohne Ihre gesonderte Zustimmung in diesem Zusammenhang keine
      Weitergabe der Daten an Dritte. Die Daten werden ausschließlich für die
      Aufrechterhaltung der Session verwendet.
    </p>
    <p>
      <strong>Zweck der Datenverarbeitung</strong>
    </p>
    <p>
      Cookies dienen der Speicherung von Daten Ihres Besuchs und zur
      Wiedererkennung wie auch zur statistischen Erfassung, Verbesserung und
      Gewährleistung des Betriebes des Data Cubes.
    </p>
    <p>
      <strong>Dauer der Speicherung</strong>
    </p>
    <p>
      Die Speicherung von Cookies erfolgt normalerweise bis zum Ende der
      Browsersitzung oder für eine in den Browsereinstellungen definierte Dauer.
    </p>
    <h1 id="ihre-rechte-als-betroffene-r-">Ihre Rechte als Betroffene(r)</h1>
    <p>
      Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie Betroffener
      im Sinne der EU-Datenschutzgrundverordnung (DSGVO) und es stehen Ihnen
      folgende Rechte gegenüber dem Verantwortlichen zu. Bitte wenden Sie sich
      dazu an den Datenschutzbeauftragten des Umweltbundesamtes (siehe oben).
    </p>
    <p>
      <strong>Auskunftsrecht - Art. 15 DSGVO</strong>
    </p>
    <p>
      Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob
      personenbezogene Daten, die Sie betreffen, von uns verarbeitet werden.{' '}
    </p>
    <p>
      Liegt eine solche Verarbeitung vor, können Sie von dem Verantwortlichen
      über folgende Informationen Auskunft verlangen:
    </p>
    <ol>
      <li>
        die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden
      </li>
      <li>
        die Kategorien von personenbezogenen Daten, welche verarbeitet werden
      </li>
      <li>
        die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die
        Sie betreffenden personenbezogenen Daten offengelegt wurden oder noch
        offengelegt werden
      </li>
      <li>
        die geplante Dauer der Speicherung der Sie betreffenden
        personenbezogenen Daten oder, falls konkrete Angaben hierzu nicht
        möglich sind, Kriterien für die Festlegung der Speicherdauer
      </li>
      <li>
        das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie
        betreffenden personenbezogenen Daten, eines Rechts auf Einschränkung der
        Verarbeitung durch den Verantwortlichen oder eines Widerspruchsrechts
        gegen diese Verarbeitung
      </li>
      <li>das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde</li>
      <li>
        alle verfügbaren Informationen über die Herkunft der Daten, wenn die
        personenbezogenen Daten nicht bei der betroffenen Person erhoben werden
      </li>
    </ol>
    <p>
      Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die Sie
      betreffenden personenbezogenen Daten in ein Drittland oder an eine
      internationale Organisation übermittelt werden. In diesem Zusammenhang
      können Sie verlangen, über die geeigneten Garantien gem. Art. 46 DSGVO im
      Zusammenhang mit der Übermittlung unterrichtet zu werden.
    </p>
    <p>
      Dieses Auskunftsrecht kann insoweit beschränkt werden, als es
      voraussichtlich die Verwirklichung der Forschungs- oder Statistikzwecke
      unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die
      Erfüllung der Forschungs- oder Statistikzwecke notwendig ist.
    </p>
    <p>
      <strong>Recht auf Berichtigung - Art. 16 DSGVO</strong>
    </p>
    <p>
      Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber
      dem Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten,
      die Sie betreffen, unrichtig oder unvollständig sind. Der Verantwortliche
      hat die Berichtigung unverzüglich vorzunehmen.
    </p>
    <p>
      Ihr Recht auf Berichtigung kann insoweit beschränkt werden, als es
      voraussichtlich die Verwirklichung der Forschungs- oder Statistikzwecke
      unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die
      Erfüllung der Forschungs- oder Statistikzwecke notwendig ist.
    </p>
    <p>
      <strong>Recht auf Einschränkung der Verarbeitung - Art. 18 DSGVO</strong>
    </p>
    <p>
      Unter den folgenden Voraussetzungen können Sie die Einschränkung der
      Verarbeitung der Sie betreffenden personenbezogenen Daten verlangen:
    </p>
    <ol>
      <li>
        wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine
        Dauer bestreiten, die es dem Verantwortlichen ermöglicht, die
        Richtigkeit der personenbezogenen Daten zu überprüfen
      </li>
      <li>
        die Verarbeitung unrechtmäßig ist und Sie die Löschung der
        personenbezogenen Daten ablehnen und stattdessen die Einschränkung der
        Nutzung der personenbezogenen Daten verlangen
      </li>
      <li>
        der Verantwortliche die personenbezogenen Daten für die Zwecke der
        Verarbeitung nicht länger benötigt, Sie diese jedoch zur Geltendmachung,
        Ausübung oder Verteidigung von Rechtsansprüchen benötigen, oder
      </li>
      <li>
        wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO
        eingelegt haben und noch nicht feststeht, ob die berechtigten Gründe des
        Verantwortlichen gegenüber Ihren Gründen überwiegen.
      </li>
    </ol>
    <p>
      Wurde die Verarbeitung der Sie betreffenden personenbezogenen Daten
      eingeschränkt, dürfen diese Daten – von ihrer Speicherung abgesehen – nur
      mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung
      von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen
      oder juristischen Person oder aus Gründen eines wichtigen öffentlichen
      Interesses der Union oder eines Mitgliedstaats verarbeitet werden.
    </p>
    <p>
      Wurde die Einschränkung der Verarbeitung nach den o.g. Voraussetzungen
      eingeschränkt, werden Sie von dem Verantwortlichen unterrichtet bevor die
      Einschränkung aufgehoben wird.
    </p>
    <p>
      Ihr Recht auf Einschränkung der Verarbeitung kann insoweit beschränkt
      werden, als es voraussichtlich die Verwirklichung der Forschungs- oder
      Statistikzwecke unmöglich macht oder ernsthaft beeinträchtigt und die
      Beschränkung für die Erfüllung der Forschungs- oder Statistikzwecke
      notwendig ist.
    </p>
    <p>
      <strong>Recht auf Löschung - Art. 17 DSGVO</strong>
    </p>
    <p>a) Löschungspflicht</p>
    <p>
      Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden
      personenbezogenen Daten unverzüglich gelöscht werden, und der
      Verantwortliche ist verpflichtet, diese Daten unverzüglich zu löschen,
      sofern einer der folgenden Gründe zutrifft:
    </p>
    <ol>
      <li>
        Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für
        die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr
        notwendig.
      </li>
      <li>
        Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem.
        Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es
        fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.{' '}
      </li>
      <li>
        Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung
        ein und es liegen keine vorrangigen berechtigten Gründe für die
        Verarbeitung vor, oder Sie legen gem. Art. 21 Abs. 2 DSGVO Widerspruch
        gegen die Verarbeitung ein.{' '}
      </li>
      <li>
        Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig
        verarbeitet.{' '}
      </li>
      <li>
        Die Löschung der Sie betreffenden personenbezogenen Daten ist zur
        Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem
        Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche
        unterliegt.{' '}
      </li>
      <li>
        Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf
        angebotene Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1
        DSGVO erhoben.
      </li>
    </ol>
    <p>b) Information an Dritte</p>
    <p>
      Hat der Verantwortliche die Sie betreffenden personenbezogenen Daten
      öffentlich gemacht und ist er gem. Art. 17 Abs. 1 DSGVO zu deren Löschung
      verpflichtet, so trifft er unter Berücksichtigung der verfügbaren
      Technologie und der Implementierungskosten angemessene Maßnahmen, auch
      technischer Art, um für die Datenverarbeitung Verantwortliche, die die
      personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als
      betroffene Person von ihnen die Löschung aller Links zu diesen
      personenbezogenen Daten oder von Kopien oder Replikationen dieser
      personenbezogenen Daten verlangt haben.{' '}
    </p>
    <p>c) Ausnahmen</p>
    <p>
      Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich
      ist
    </p>
    <ol>
      <li>
        zur Ausübung des Rechts auf freie Meinungsäußerung und Information
      </li>
      <li>
        zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach
        dem Recht der Union oder der Mitgliedstaaten, dem der Verantwortliche
        unterliegt, erfordert, oder zur Wahrnehmung einer Aufgabe, die im
        öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt
        erfolgt, die dem Verantwortlichen übertragen wurde
      </li>
      <li>
        aus Gründen des öffentlichen Interesses im Bereich der öffentlichen
        Gesundheit gemäß Art. 9 Abs. 2 lit. h und i sowie Art. 9 Abs. 3 DSGVO
      </li>
      <li>
        für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche
        oder historische Forschungszwecke oder für statistische Zwecke gem. Art.
        89 Abs. 1 DSGVO, soweit das unter Abschnitt a) genannte Recht
        voraussichtlich die Verwirklichung der Ziele dieser Verarbeitung
        unmöglich macht oder ernsthaft beeinträchtigt, oder
      </li>
      <li>
        zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
      </li>
    </ol>
    <p>
      <strong>Recht auf Unterrichtung</strong>
    </p>
    <p>
      Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der
      Verarbeitung gegenüber dem Verantwortlichen geltend gemacht, ist dieser
      verpflichtet, allen Empfängern, denen die Sie betreffenden
      personenbezogenen Daten offengelegt wurden, diese Berichtigung oder
      Löschung der Daten oder Einschränkung der Verarbeitung mitzuteilen, es sei
      denn, dies erweist sich als unmöglich oder ist mit einem
      unverhältnismäßigen Aufwand verbunden.
    </p>
    <p>
      Ihnen steht gegenüber dem Verantwortlichen das Recht zu, über diese
      Empfänger unterrichtet zu werden.
    </p>
    <p>
      <strong>Recht auf Datenübertragbarkeit - Art. 20 DSGVO</strong>
    </p>
    <p>
      Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie
      dem Verantwortlichen bereitgestellt haben, in einem strukturierten,
      gängigen und maschinenlesbaren Format zu erhalten. Außerdem haben Sie das
      Recht diese Daten einem anderen Verantwortlichen ohne Behinderung durch
      den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt
      wurden, zu übermitteln, sofern
    </p>
    <ol>
      <li>
        die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO
        oder Art. 9 Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs.
        1 lit. b DSGVO beruht und
      </li>
      <li>die Verarbeitung mithilfe automatisierter Verfahren erfolgt.</li>
    </ol>
    <p>
      In Ausübung dieses Rechts haben Sie ferner das Recht, zu erwirken, dass
      die Sie betreffenden personenbezogenen Daten direkt von einem
      Verantwortlichen einem anderen Verantwortlichen übermittelt werden, soweit
      dies technisch machbar ist. Freiheiten und Rechte anderer Personen dürfen
      hierdurch nicht beeinträchtigt werden.
    </p>
    <p>
      Das Recht auf Datenübertragbarkeit gilt nicht für eine Verarbeitung
      personenbezogener Daten, die für die Wahrnehmung einer Aufgabe
      erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung
      öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde.
    </p>
    <p>
      <strong>Widerspruchsrecht - Art. 21 DSGVO</strong>
    </p>
    <p>
      Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation
      ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden
      personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f
      DSGVO erfolgt, Widerspruch einzulegen.{' '}
    </p>
    <p>
      Der Verantwortliche verarbeitet die Sie betreffenden personenbezogenen
      Daten nicht mehr, es sei denn, er kann zwingende schutzwürdige Gründe für
      die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
      überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder
      Verteidigung von Rechtsansprüchen.
    </p>
    <p>
      Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten
      der Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr
      Widerspruchsrecht mittels automatisierter Verfahren auszuüben, bei denen
      technische Spezifikationen verwendet werden.
    </p>
    <p>
      Sie haben auch das Recht, aus Gründen, die sich aus Ihrer besonderen
      Situation ergeben, bei der Verarbeitung Sie betreffender personenbezogener
      Daten, die zu wissenschaftlichen oder historischen Forschungszwecken oder
      zu statistischen Zwecken gem. Art. 89 Abs. 1 DSGVO erfolgt, dieser zu
      widersprechen.
    </p>
    <p>
      Ihr Widerspruchsrecht kann insoweit beschränkt werden, als es
      voraussichtlich die Verwirklichung der Forschungs- oder Statistikzwecke
      unmöglich macht oder ernsthaft beeinträchtigt und die Beschränkung für die
      Erfüllung der Forschungs- oder Statistikzwecke notwendig ist.
    </p>
    <p>
      <strong>
        Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung -
        Art. 7 Abs. 3 DSGVO
      </strong>
    </p>
    <p>
      Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung
      jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die
      Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
      Verarbeitung nicht berührt.
    </p>
    <p>
      <strong>Recht auf Beschwerde bei einer Aufsichtsbehörde</strong>
    </p>
    <p>
      Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen
      Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer
      Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts,
      ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, zu, wenn
      Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
      personenbezogenen Daten gegen die DSGVO verstößt.{' '}
    </p>
    <p>
      Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde,
      unterrichtet den Beschwerdeführer über den Stand und die Ergebnisse der
      Beschwerde einschließlich der Möglichkeit eines gerichtlichen
      Rechtsbehelfs nach Art. 78 DSGVO.
    </p>
    <p>
      Die im Falle des Umweltbundesamtes zuständige Aufsichtsbehörde ist die /
      der{' '}
      <a href="https://www.bfdi.bund.de/DE/Home/home_node.html">
        Bundesbeauftragte für den Datenschutz und die Informationsfreiheit.
      </a>
    </p>
    <h1 id="rechtswirksamkeit-dieses-haftungsausschlusses">
      Rechtswirksamkeit dieses Haftungsausschlusses
    </h1>
    <p>
      Dieser Haftungsausschluss ist als Teil des Internetangebotes zu
      betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder
      einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht,
      nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen
      Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
    </p>
    <h1 id="nutzung-von-auf-unserer-website-ver-ffentlichten-personenbezogenen-daten">
      Nutzung von auf unserer Website veröffentlichten personenbezogenen Daten
    </h1>
    <p>
      Die missbräuchliche Nutzung von Daten aus dem Impressum, aus Kontaktboxen
      oder vergleichbare Angaben von durch uns veröffentlichten Kontaktdaten wie
      Postanschriften, Telefon- und Faxnummern sowie E-Mailadressen ist nicht
      gestattet. Rechtliche Schritte gegen die Versender von so genannten
      Spam-Mails bei Verstößen gegen dieses Verbot sind ausdrücklich
      vorbehalten.
    </p>
    <p>
      <notes>Letzte Aktualisierung dieser Seite: 13.05.2025</notes>
      <br />
      &copy; 2024 Umweltbundesamt Dessau-Roßlau. Alle Rechte vorbehalten
    </p>
  </Fragment>
);
export default PrivacyText_de;
